import React, { PropTypes } from 'react';

import { info } from './styles.module.css';

/**
 * Footer info presentational component.
 */
const FooterInfo = ({ children, className }) => (
  <div className={`${info} ${className}`}>{children}</div>
);

FooterInfo.propTypes = {
  /**
   * Children contents of component.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
};

FooterInfo.defaultProps = {
  className: '',
};

export default FooterInfo;



// WEBPACK FOOTER //
// ./app/src/components/Footer/components/FooterInfo/index.jsx